// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ww-2q","paragraph":"styles_paragraph__H4j8w"};